export default __webpack_public_path__ + "static/media/003-basin.77130e84.svg";